const TUTORIALS = [
  {
    id: "setup",
    title: "Create account + install MinutePay",
    description: "Register, add MinutePay from the Chrome Web Store, and sign in so tracking is ready.",
  },
  {
    id: "first-call",
    title: "Track your first InterpreterCloud call",
    description: "Open InterpreterCloud, take a call, and see minutes and earnings save automatically.",
  },
  {
    id: "dashboard",
    title: "Dashboard, History & Monthly Goals",
    description: "Read your overview, filter history, and set a monthly income target with daily pacing.",
  },
];

export default function EducationPage() {
  return (
    <div className="mpd-page">
      <div className="mpd-page-head">
        <div>
          <h1>Education</h1>
          <p className="mpd-sub">Short tutorials to get MinutePay working on InterpreterCloud.</p>
        </div>
      </div>
      <section className="mpd-edu-grid">
        {TUTORIALS.map((item) => (
          <article key={item.id} className="mpd-card mpd-edu-card">
            <div className="mpd-edu-thumb mpd-edu-soon">
              <span>Tutorial coming soon</span>
            </div>
            <div className="mpd-edu-body">
              <h2>{item.title}</h2>
              <p>{item.description}</p>
              <span className="mpd-edu-watch is-soon">Coming soon</span>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
